module.exports = __webpack_public_path__ + "static/media/apropos_title_ar.fbcd9000.png";